<template>

    <div id="appContent" v-if="appConfigCRM && con && access">

        <splash-mini :time="2000" :welcome="true"></splash-mini>

        <img :src="background" class="cache opacity-0 pe-none"><!-- cache para menu central -->

        <toast :newMessage="toast" @playSound="playSound"></toast>
        <notify :storeIcon="this.appConfigCRM.logo || ''" :active="notify[0]" :message="notify[1]" :type="notify[2]" :timeAuto="notify[3]" :buttonText="notify[4]" :returned="notify[5]" :auto="notify[6]" :toggle="notify[7]" :bolQuest="notify[8]" @closeNotify="toggleNotify"></notify>
        <note-modal v-if="modals.rNote.status" @goBack="closeRNote"></note-modal>
        <dev-conf :printer="printer" v-if="modals.devConf.status" @electronPass="sendToElectron" @toast="setToast" @close="changeDevConf(false)" :catchResponseElectron="responseElectron" :catchResponseWS="responseWS"></dev-conf>

        <div v-if="this.$route.name != 'rewardIdentificator' && this.$route.name != 'logScreen' && this.$route.name != 'addTable' && this.$route.name != 'addTableHostess' && this.$route.name != 'MenuEntrance'" class="headerMenu w-100" :class="isElectron ? 'headerElectron' : 'headerCordova'">
            <menu-app :config="this.appConfigCRM" :printer="printer" :catchResponseElectron="responseElectron" :catchResponseWS="responseWS" @toRoute="goToRoute" @logout="logout" @passingData="filterEvent"></menu-app>
        </div>

        <router-view v-slot="{ Component, route }"  @toRoute="goToRoute">
            <transition :name="route.meta.transition" :mode="route.meta.mode">
            <component :is="Component" :printer="printer" :config="this.appConfigCRM" :con="con" :catchResponseWS="responseWS" :catchResponseElectron="responseElectron" :serverDate="serverDate" @sendDataWS="catchActionToWS"  @logout="logout" @toRoute="goToRoute"  @logSucess="setOrders" @electronPass="sendToElectron" @passingData="filterEvent" @toast="setToast"/>
            </transition>
        </router-view>

        <div id="errorConection" v-if="!onLine">
            <span class="w-100 d-flex justify-content-center">
                No hay acceso al servidor o su conexión de red esta fuera de línea
            </span>
            <img :src="require('@/assets/images/a24.svg')" class="off">
        </div>

        <template v-if="appConfigCRM.ws.active && !modularWSOff"> <!-- modularOff indica que no tiene modulos que utilicen websocket en la configuración-->
            <template v-if="appConfigCRM.modules.includes('reserves') || appConfigCRM.modules.includes('reservesLimited')"> 
                <div id="updatingAPP" v-if="updatingAPP">
                    <span class="w-100 d-flex justify-content-center">
                        Efisense CRM en proceso de actualización...
                    </span>
                    <img :src="require('@/assets/images/a15.png')" class="off">
                </div>

                <div id="tryingWebsocket" v-if="tryingWebsocket.onico">
                    <span class="w-100 d-flex justify-content-center text-center mb-2">
                        Sincronizando conexión onico...
                    </span>
                    <img :src="require('@/assets/images/a24.svg')" class="off mt-2">
                </div>
        
                <div id="errorWebsocket" v-if="!wsOn.onico">
                    <span class="w-100 d-flex justify-content-center">
                        Error en websocket, restableciendo conexión onico...
                    </span>
                    <img :src="require('@/assets/images/a24.svg')" class="off">
                </div>
        
                <div id="a25" v-if="closedAccountDub.onico">
                    <span class="w100 d-flex justify-content-center mt-2">
                        <img :src="require('@/assets/images/a25.svg')" class="off">
                    </span>
                    <span class="col-md-12 col-10 d-flex justify-content-center text-center mt-4 px-2">
                        Su sessión onico ha sido abierta en otro dispositivo
                    </span>
                    <div class="w-100 text-center mt-4">
                        <button class="btn-ok" @click="reload()">
                            Retomar sesion en este dispositivo
                        </button>
                    </div>
                </div>
            </template>

            <template v-if="appConfigCRM.modules.includes('listOrders')"> 
                <div id="updatingAPP" v-if="updatingAPP">
                    <span class="w-100 d-flex justify-content-center">
                        Efisense CRM en proceso de actualización...
                    </span>
                    <img :src="require('@/assets/images/a15.png')" class="off">
                </div>

                <div id="tryingWebsocket" v-if="tryingWebsocket.crm">
                    <span class="w-100 d-flex justify-content-center text-center mb-2">
                        Sincronizando conexión crm...
                    </span>
                    <img :src="require('@/assets/images/a24.svg')" class="off mt-2">
                </div>
        
                <div id="errorWebsocket" v-if="!wsOn.crm">
                    <span class="w-100 d-flex justify-content-center">
                        Error en websocket, restableciendo conexión crm...
                    </span>
                    <img :src="require('@/assets/images/a24.svg')" class="off">
                </div>
        
                <div id="a25" v-if="closedAccountDub.crm">
                    <span class="w100 d-flex justify-content-center mt-2">
                        <img :src="require('@/assets/images/a25.svg')" class="off">
                    </span>
                    <span class="col-md-12 col-10 d-flex justify-content-center text-center mt-4 px-2">
                        Su sessión crm ha sido abierta en otro dispositivo
                    </span>
                    <div class="w-100 text-center mt-4">
                        <button class="btn-ok" @click="reload()">
                            Retomar sesion en este dispositivo
                        </button>
                    </div>
                </div>
            </template>

        </template>

    </div>

    <div id="noConfig" v-else>
        <div id="errorConection" v-if="!onLine">
            <span class="w-100 d-flex justify-content-center">
                No hay acceso al servidor o su conexión de red esta fuera de línea
            </span>
            <img :src="require('@/assets/images/a24.svg')" class="off">
        </div>
        <get-config v-else @setAccessKeys="setAccessKeys"></get-config>
    </div>

    <div v-if="updateVersion" id="updateScreen" class="d-flex justify-content-center align-items-start align-content-start flex-wrap py-5 font-1-1">
        <div class="col-10 d-flex align-items-center align-content-center justify-content-end"><img :src="a48" class="icon1" @click="closeUpdateScreen()"></div>
        <div class="col-10 d-flex align-items-center align-content-center justify-content-start mt-xl-5 mb-3" @click="openPlayStore()"><img :src="a52" class="icon2"></div>
        <div class="col-10 d-flex align-items-center align-content-center justify-content-start stringVersionTitle text-start mt-4" @click="openPlayStore()">Su sistema se encuentra<br>desactualizado.</div>
        <div class="col-10 d-flex flex-wrap align-items-center align-content-center justify-content-start ps-4 stringVersion text-start mt-4" @click="openPlayStore()">
            <div class="w-100 text-start mt-3">Versión instalada {{versionNowText}}</div>
            <div class="w-100 text-start mt-3">Versión del servidor {{versionToUpdateText}}</div>
        </div>        
    </div>
    
</template>

<script lang="js">


// Inicializar IndexedDB al cargar la aplicación
import { overrideConsoleLog, createLogFileAndSend } from './assets/js/loger.js'
import  { printerSystemCordova } from '@/assets/js/cordovaPrinter.js';
import toast from "@/components/modal/modalType/NotificationToast.vue";
import Notify from '@/components/modal/modalType/NotificationModal.vue'
import  { request } from '@/assets/js/requests.js';
import splashMini from "@/components/common/SplashMini.vue";
import getConfig from "@/components/common/GetConfiguration.vue";
import noteModal from "@/components/modal/NoteMod.vue";
import devConf from "@/components/common/DeviceConfiguration.vue";
import MenuApp from '@/components/common/Menu.vue'

import audiodataBlink from "@/assets/audio/blink.json";
import audiodataCheck from "@/assets/audio/check.json";
import audiodataError from "@/assets/audio/error.json";
import audiodataIntro from "@/assets/audio/intro.json";
import audiodataPop from "@/assets/audio/pop.json";
import audiodataToast from "@/assets/audio/toast.json";

overrideConsoleLog()

export default {
    name: "app",
    components:{
        getConfig,
        toast,
        noteModal,
        devConf,
        MenuApp,
        splashMini,
        Notify
    },

    beforeCreate(){

        if (sessionStorage.ws) { //incremente el id del objeto websocket para solo utilizar el último creado
            this.stringWS = parseInt(sessionStorage.ws);
            ++this.stringWS;
            sessionStorage.setItem('ws', this.stringWS);
        } else {
            sessionStorage.setItem('ws', 1);
            this.stringWS = 1;
        }

        if (!window.ipcRenderer) { //comunicador con electron
            window.ipcRenderer = { receive: function () { return false }, send: function () { return false } };
        }

        if(localStorage.status){ // no borra los datos de logueo anterior
            if(localStorage.status == "updating"){
                this.logedUpdate = true;
                sessionStorage.setItem('on', "true")
            }else{
                this.logedUpdate = false;
            }
        }else{ // <-- quiere decir que viene de una antigua actualización, acaba de actualizar
            this.logedUpdate = true;
            sessionStorage.setItem('on', "true") // omite el splash
        }
    },

    beforeMount() {
        window.addEventListener('playSoundSplash', (event) => {
            try{
                //this.playSound('intro');
            }catch(err){}
        });
        
    },

    beforeUnmount(){
        if(this.isCordova){
            document.removeEventListener('pause', this.onPause, false);
            document.removeEventListener('pause', this.onResume, false);
        }
    },

    mounted(){

        this.initialFunctions();

        if(this.appConfigCRM){
            console.log('[device] preparando envio de logs');
            createLogFileAndSend(this.appConfigCRM.idTerminal, this.appConfigCRM.token);
        }

        localStorage.setItem("status", 'normal');

        window.ipcRenderer.receive('appAction', (event, data) => {
            console.log('[device] evento de electron -> " ', event, ' "->', data)
            this.responseFromElectron(event, data);
        })

        if (this.appConfigCRM && this.access && this.con) {
            this.prepareRun();
        }
    },

    data() {
        return {
            versionToUpdateText:'',
            versionNowText:'',
            updateVersion:false,
            access:false, 

            printer:new printerSystemCordova,
            appConfigCRM: (localStorage.appConfigCRM) ? JSON.parse(localStorage.appConfigCRM) : false,
            con: (localStorage.appConfigCRM) ?  new request(JSON.parse(localStorage.appConfigCRM)) : false,

            serverDate: new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Mexico_City' })),
            addTime: 1000,

            modularWSOff:false, //websocket activo pero sin modulos que la utilicen
            crmSocket:false,
            onicoSocket:false,
            ws: {onico:null, crm:null}, //objeto de conexion
            wsOn: {onico:false, crm:false}, //indica conexion completa
            logedWS:{onico:false, crm:false},
            tryingWebsocket:{onico:false, crm:false},
            manualClosedWS: {onico:false, crm:false}, //indica que se cerro websocket por orden de javascrpt
            closedAccountDub: {onico:false, crm:false}, //indica cuenta abierta en otro sitio
            groupActive: 0, // esto es para ws onico escuche todos las agendas de su licencia

            onLine: navigator.onLine ? true : false,
            linger: false, //es un helper para contar tiempo de desconexion
            updatingAPP: false, //ventana de animación

            responseWS: { destiny: null, message: "", status: false, for: "" },
            //objecto que heredaran los hijos para discernir si les incumbe la respuesta de websocket
            responseElectron: { destiny: null, payload: {}, reload: false },

            interval:null,
            developer: process.env['PRODUCTION'] ? false : true,

            modals: { rNote: { status: false }, devConf: {status :false} },
            toast:{mess:"",time:""},
            logo:require('@/assets/images/a19.png'),
            a52:require('@/assets/images/a52.svg'),
            a48: require('@/assets/images/a48.svg'),

            background:null,

            //impresion
            printerHardwareList: {},
            audios:{
                check:null,
                blink:null,
                error:null,
                intro:null,
                pop:null,
                toast:null
            },

            notify: [false, "", "", 5, "", [""], true, true, false],
            lastRoute:{},

            failsCleanerTimerOnico: null,
            countFailsOnico:0,
            hibernatingTimer: setTimeout(()=>{}, 0),
            systemStatus: 'running'
        }
    },

    methods: {

        closeUpdateScreen(){
            this.updateVersion = false;
        },

        openPlayStore(){
            console.log('[device] usuario -> a tienda')
            const playStoreAppUrl = 'market://details?id=com.vue.efisensecrm.mobile.app';
            const playStoreWebUrl = 'https://play.google.com/store/apps/details?id=com.vue.efisensecrm.mobile.app';

            try {
                cordova.InAppBrowser.open(playStoreAppUrl, '_system');
            } catch (error) {
                // Si falla abrir el esquema "market://", redirige a la versión web
                cordova.InAppBrowser.open(playStoreWebUrl, '_system');
            }
        },

        async checkAppVersion(){
            this.con.getVersions().then(response => {
                if(response.data.efisenseCRM){
                    if(this.isCordova){

                        let availables = {...response.data.efisenseCRM.app};
                        this.versionToUpdateText = availables.releases[availables.releases.length - 1];
                        //let releaseNotes = availables.comments;
                        availables.releases = availables.releases.map(a => a.split('.').map(n => +n + 10000).join('.')).sort().reverse().map(a => a.split('.').map(n => +n - 10000).join('.'));
                        availables.releases = availables.releases.map(a => a.split('.').map(n => +n + 10000).join('')).sort().reverse();
                        let versionToUpdate = availables.releases[0];

                        cordova.getAppVersion.getVersionNumber()
                        .then((version) => {
                            
                            this.versionNowText = version;

                            let versionNow = version.split('.').map(n => +n + 10000).join('');
                            if(versionNow < versionToUpdate){
                                console.log('[aviso de actualizacion]:', versionNow, versionToUpdate)
                                this.updateVersion = true;
                            }
                        })
                        .catch((error) => {
                            console.error('[Error] obteniendo version de app:', error);
                        });
                        
                    }
                }

            }).then(()=>{

            })
            
        },

        eraseCar(){
            if(localStorage.car){
                let tokenCar = JSON.parse(localStorage.car);
                localStorage.setItem('car', "[]");
                for(let i=0; i < tokenCar.length; i++){
                    localStorage.removeItem(tokenCar[i]);
                }
            }
        },

        toggleNotify(returned){
			this.notify[0] = false;
            if(returned == "eraseCarContinue"){
                this.eraseCar()
                this.goToRoute(this.lastRoute.data, this.lastRoute.mode)
			}   
		},

        onResume(){
            if(this.systemStatus == 'hibernating'){
                this.systemStatus = 'running';
                clearTimeout(this.hibernatingTimer);
                console.log('------ -resumiendo y limpiando hibernacion- ------')
                console.log('[time] poniendo hora de dispositivo por default');
                this.serverDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
                this.refreshingTime();
                if(this.onicoSocket){
                    console.log('[ws] reconectando onicoWS luego de hibernar')
                    this.manageErrWS('onico', this.wsOn.onico, 0);
                }
                if(this.crmSocket){
                    console.log('[ws] reconectando crmWS luego de hibernar')
                    this.manageErrWS('crm', this.wsOn.crm, 0);
                }
            }else{
                console.log('[device] resumiendo y limpiando hibernacion')
                clearTimeout(this.hibernatingTimer);
                this.systemStatus = 'running';
            }
            if(this.appConfigCRM){
                console.log('[api] preparando envio de logs');
                createLogFileAndSend(this.appConfigCRM.idTerminal, this.appConfigCRM.token);
            }            
        },

        onPause(){
            this.systemStatus = 'pause';
            this.hibernatingTimer = setTimeout(()=>{
                console.log('[try] esperando hibernación')
                if(this.systemStatus == 'pause'){
                    this.systemStatus = 'hibernating';
                    console.log('[ws] hibernando y desconectando WS')
                    if(this.onicoSocket){
                        this.forceCloseWS('onico');
                    }
                    if(this.crmSocket){
                        this.forceCloseWS('crm');
                    }
                }
            }, 5000)
        },

        setAccessKeys(data){
            for(let i in data){
                this[i] = data[i];
            }
            this.con = (localStorage.appConfigCRM) ?  new request(JSON.parse(localStorage.appConfigCRM)) : false;
            this.prepareRun();
        },

        prepareRun(){
            if (this.appConfigCRM) {

                this.appConfigCRM.logoAPP = this.logo;

                this.setTerminalID(); // variable de identificacion websocket
                this.goFirst(); //vista inicial
                this.checkAndSetPrinterOptions(); //variable locales de impresoras-impresion
                this.getAudios().then((res)=>{}); //sonidos de aplicación

                if(this.isCordova){ //si se carga dentro de app movil

                    document.addEventListener('deviceready', () => {

                        this.checkAppVersion();

                        document.addEventListener('pause', this.onPause, false);
                        document.addEventListener('resume', this.onResume, false);

                        if (device.platform === 'Android') {
                            screen.orientation.lock('landscape-primary').catch(err => {
                                console.error('[device/cordova] Error al bloquear orientación en Android:', err);
                            });
                        } else if (device.platform === 'iOS') {
                            if (parseInt(device.version) >= 13) {
                                screen.orientation.lock('landscape-primary').catch(err => {
                                    console.error('[device/cordova] Error al bloquear orientación en iOS:', err);
                                });
                            } else {
                                console.log('[device/cordova] No se puede bloquear orientación en iOS 12 o inferior');
                            }
                        }

                        this.start();

                        this.printer.getLogo(this.appConfigCRM.logo);
                        cordova.plugins.notification.local.setDefaults({
                            led: { color: '#2699fb', on: 500, off: 500 },
                            vibrate: false
                        });

                        this.checkNotificationPermitions();

                        cordova.plugins.notification.local.on('getNowOrders', (notification, eopts) => { 
                            if(this.$route.name == 'listOrders'){
                                this.responseWS = {
                                    "destiny": ["listOrders"],
                                    "for": "getNewOrders",
                                    "origin": "notifications",
                                    "reload": false,
                                }
                            }else{
                                this.goToRoute({dir:'/listOrders', parameters:{get:"confirmOrdersToday", time:new Date()}}, "replace");
                            }
                        });

                    }, false);

                }else if(this.isElectron){ //si se carga dentro de sistema de escritorio

                    this.start();
                    this.sendToElectron('configAPP', JSON.parse(localStorage.appConfigCRM))

                }else{ //visor web
                    this.start();
                }


                /*setInterval(()=>{
                    let data =  {
                        "cmd": "notifications",
                        "message": "Citas ",
                        "action": "newOrders",
                        "error": false,
                        "payload": {
                            "title": "Orden nueva",
                            "message": "(1) Delivery Rappi",
                            "action": "newOrders",
                            "responseDB": true,
                            "sound": "toast",
                            "error": false,
                        }
                    }

                    console.log('envioado')

                    this.filterNotificacion(data)
                
                }, 10000)*/
            }
        },

        closeRNote(){
            this.modals.rNote.status = false;
        },

        alertRelease(){
            if(this.logedUpdate && localStorage.versionNote && !this.modals.devConf.status){
                this.modals.rNote.status = true;
            }
        },

        setNewReleaseAlert(data){
            let availables = Object.keys(data)
            for(let i=0; i < availables.length; i++){
                if(String(availables[i]) == String(this.version)){
                    localStorage.setItem('versionNote', data[availables[i]])
                    this.alertRelease();
                    break;
                }
            }
        },
        
        checkNotificationPermitions(){
            cordova.plugins.notification.local.hasPermission( (granted) => {
                if(!granted){
                    cordova.plugins.notification.local.requestPermission( (grantedNow) => {
                        if(!grantedNow){
                            this.setToast('Las notificaciones estan desactivadas desde configuración', "pop");
                            localStorage.removeItem('systemNotificationsOff', true)
                        }else{
                            localStorage.removeItem('systemNotificationsOff')
                        }
                    });
                }
            });
        },

        setToast(message, sound="pop"){
            console.log('[mensaje flotante]:'+ message);
            this.toast = {mess:message, time:new Date(), type:sound};
        },

        /* audio */

        playSound(name) {
            try {
                // Verificamos si el archivo está guardado en el objeto `this.audios`
                if (this.audios[name]) {
                    if(this.isCordova){
                        // Crear un objeto Media con la ruta del archivo guardado
                        const media = new Media(this.audios[name], 
                            // Éxito al reproducir
                            () => {
                                console.log(`[device] Reproduciendo audio: ${name}`);
                            },
                            // Error al reproducir
                            (err) => {
                                console.error('[Error] al reproducir el audio:', err);
                            }
                        );

                        // Reproducir el audio
                        media.play();
                    }else{
                        this.audios[name].play(); 
                    }
                } else {
                    console.error(`[error] No se encontró el audio para ${name}`);
                }
            } catch (err) {
                console.error('[Error] al intentar reproducir el audio:', err);
            }
        },

        setAudio(file, pos) {
            return new Promise((resolve, reject) => {
                if(this.isCordova){
                    try {
                        // Obtener el directorio de almacenamiento de la aplicación
                        window.resolveLocalFileSystemURL(cordova.file.dataDirectory, (directoryEntry) => {
                            // Crear un archivo nuevo con el nombre de la posición
                            directoryEntry.getFile(pos + ".mp3", { create: true, exclusive: false }, (fileEntry) => {
                                // Crear el Blob desde los datos base64
                                const audioData = this.base64ToBlob(file.audio.data);
                                
                                // Escribir el archivo
                                fileEntry.createWriter((fileWriter) => {
                                    fileWriter.write(audioData);
                                    fileWriter.onwriteend = () => {
                                        console.log(`[device] Audio guardado: ${pos}`);
                                        this.audios[pos] = fileEntry.nativeURL; // Guardamos la ruta del archivo
                                        resolve(true);
                                    };
                                    fileWriter.onerror = (err) => {
                                        console.error('[Error] al escribir el archivo:', err);
                                        reject(err);
                                    };
                                });
                            });
                        });
                    } catch (err) {
                        console.error('[Error] al guardar el audio:', err);
                        reject(err);
                    }
                }else{
                    try{
                        this.audios[pos] = new Audio("data:audio/mpeg;base64,"+file.audio.data);
                        this.audios[pos].crossOrigin = "anonymous";
                        this.audios[pos].load();
                        resolve(true)
                    }catch(err){
                        console.log('[error]', err)
                        resolve(true)
                    }   
                }
            });
        },

        // Convertir base64 a Blob
        base64ToBlob(base64) {
            const binaryString = atob(base64); // Decodificar base64
            const length = binaryString.length;
            const uintArray = new Uint8Array(length);
            for (let i = 0; i < length; i++) {
                uintArray[i] = binaryString.charCodeAt(i);
            }
            return new Blob([uintArray], { type: 'audio/mpeg' });
        },

        getAudios(){
            return new Promise(async (resolve)=>{
                let tempFiles = [audiodataBlink, audiodataCheck, audiodataError, audiodataIntro, audiodataPop, audiodataToast];

                Object.keys(this.audios).forEach(async (name, index) => {
                    await this.setAudio(tempFiles[index], name)
                });

                resolve(true)
            })
        },

        /* ---- */
        /* modal de configuracion de dispositivo */

        changeDevConf(mode=false){
            if(mode){
                this.modals.devConf.status = true;
                return false;
            }
            this.modals.devConf.status = false;
            return false
        },

        checkAndSetPrinterOptions(){
            if(localStorage.printerTypeSelected){
                if(localStorage.printerTypeSelected != null && localStorage.printerTypeSelected != ""){
                    if(localStorage.printerSelected){
                        if(localStorage.printerSelected != null && localStorage.printerSelected != ""){
                            if(this.isElectron){
                                this.sendToElectron('setPrintType', {data: localStorage.printerTypeSelected});
                                this.sendToElectron('setPrintConfig', localStorage.printerSelected);
                            }
                            return true
                        }
                    }
                }
            }
            return false
        },

        /* ---- */
        /* funciones iniciales */
    
        setTerminalID(){
            this.groupActive = Number(this.appConfigCRM.idTerminal);
            localStorage.setItem('groupActive', this.groupActive);
        },

        goFirst(){
            this.goToRoute({destiny:'/'}, "replace");
            setTimeout(()=>{
                switch(true){
                    case (this.appConfigCRM.initial == "restaurant" && this.appConfigCRM.modules.includes('restaurant')):
                        this.goToRoute({destiny:'/logScreen'}, "replace");
                        break;
                    case (this.appConfigCRM.initial == "listOrders" && this.appConfigCRM.modules.includes('listOrders')):
                        this.goToRoute({destiny:'/listOrders'}, "replace");
                        break;
                    case (this.appConfigCRM.initial == "callCenter" && this.appConfigCRM.modules.includes('callCenter')):
                        this.goToRoute({destiny:'/callCenter'}, "replace");
                        break;
                    case (this.appConfigCRM.initial == "reserves" && (this.appConfigCRM.modules.includes('reserves') || this.appConfigCRM.modules.includes('reservesLimited'))):
                        this.goToRoute({destiny:'/reserves'}, "replace");
                        break;
                    default:{
                        try{
                            if(this.appConfigCRM.initial != '' && this.appConfigCRM.initial != null){
                                let finded = false;
                                this.$router.options.routes.forEach((route, index) => {
                                    if(route.component.name == this.appConfigCRM.initial){
                                        finded = true;
                                        this.goToRoute({destiny:'/'+this.appConfigCRM.initial}, "replace");
                                        return true;
                                    }
                                    if(this.$router.options.routes.length == index+1 && !finded){
                                        this.goToRoute({destiny:'/'}, "replace");
                                        return false;
                                    }
                                });
                            }else{
                                this.goToRoute({destiny:'/'}, "replace");
                            }
                        }catch(err){
                            this.goToRoute({destiny:'/'}, "replace");
                        }
                    }
                }
            }, 1000)
        },

        initialFunctions(){
            window.addEventListener('offline', e => { //detecta corte de conexion de red
                console.log('[device/red] conexion de red perdida')
                this.onLine = false;
                this.timer(60000).then(() => {
                    if (!this.onLine) {
                        this.linger = true; //para detectar si espero los 3 segundos
                    }
                })
            })

            window.addEventListener('online', e => { //detecta union de conexion de red
                console.log('[device/red] conexion de red establecida')
                if(!this.access){
                    this.reload();
                }
                if (this.linger) {
                    this.reload();
                } else {
                    this.onLine = true;
                }
            })
        },

        start() {

            if (this.onLine && this.appConfigCRM.ws.active) { // inicializa los ws si contienen en su configuracion permisos para ver los apartados que lo usan
                if(this.appConfigCRM.modules.includes('reserves') || this.appConfigCRM.modules.includes('reservesLimited')){
                    this.activeOnicoWS();
                    this.onicoSocket = true;
                }
                if(this.appConfigCRM.modules.includes('listOrders')){
                    this.activeCRMWS();
                    this.crmSocket = true;
                }
                if(!this.appConfigCRM.modules.includes('listOrders') && !this.appConfigCRM.modules.includes('reserves') && !this.appConfigCRM.modules.includes('reservesLimited')){
                    this.modularWSOff = true; // en caso que no tenga permisos para ninguno
                }
            }
        },

        /* FILTERS WS && ELECTRON */
        /* ELECTRON RELATED */

        responseFromElectron(event, data) {
            //filtro de resultados de Electron -> reciben componentes hijos
            switch (event) {
                case "usbList":
                    this.sendUsbList(data)
                    break;
                case "openConfigDevice":
                    this.modals.devConf.status = true;
                    break;
                case "setTitle":
                    this.setTitle(data);
                    break;
                case "ready":
                    this.ready = true;
                    this.setTitle('CRM');
                    break;
                case "system":
                    switch(data){
                        case 'suspend':
                            this.forceCloseWS('onico');
                            break;
                        case 'resumen':
                            this.timer(1000).then(()=>{
                                this.manageErrWS('onico', this.wsOn.onico);
                            })
                            break;
                    }
                    break;          
                case "updating":
                    localStorage.setItem("status", 'updating');
                    break;
                case "errorUpdate":
                    localStorage.setItem("status", 'normal');
                    break;
                case "openReleaseNote":
                    if(localStorage.versionNote && !this.modals.devConf.status){
                        this.modals.rNote.status = true;
                    }
                    break;
                case "newReleaseNotes":
                    this.setNewReleaseAlert(data)
                    break;
            }
        },

         // >>> ENVIO HACIA ELECTRON >>>

        sendToElectron(action, payload) {
            //envia directamente al puente electron-app
            window.ipcRenderer.send("appAction", action, payload);
        },



        /* WEBSOCKET RELATED */

        catchActionToWS(data) {

            console.log('[ws] enviaria ->  ', data)

            switch(data.socket){
                case 'onico':
                    switch (data.action) {
                        case 'logout':
                            this.logedWS.onico = false;
                            this.timeLogRuned = 1;
                            break;
                        case 'busy':
                            this.spaceTemporal(data.params, data.action)
                            break;
                        case 'release':
                            this.spaceTemporal(data.params, data.action)
                            break;
                        case 'openEdit':
                            this.appointReservation(data.params, data.action)
                            break;
                        case 'closeEdit':
                            this.appointReservation(data.params, data.action)
                            break;
                        case 'changeDoctor':
                            this.changeDoctorListening(data.params);
                            break;
                        case 'reset':
                            if(this.logedWS.onico){
                                this.forceCloseWS('onico');
                            }
                            this.tryResetWS('onico');
                            break;
                    }
                    break;
                case 'crm':
                    break;
                default:
                    break;
            }
        },

        catchResponseFromOnicoWS(data) {
            //filtro de resultados de websocket-> reciben componentes hijos
            if (data.hasOwnProperty('cmd') && data.hasOwnProperty('error')) {

                switch (data.cmd) {
                    case 'login':
                        this.sucessLogin(data);
                        this.setServerDate(data.payload.timeStamp);
                        this.refreshingTime();
                        this.getServerTime();
                        break;
                    case 'newEventTeam':
                        this.newEventTeamReceived(data);
                        break;
                    case 'newEventResponse':
                        this.newEventResponseReceived(data);
                        break;
                    case 'updateEventTeam':
                        this.updateEventTeamReceived(data);
                        break;
                    case 'updateEventResponse':
                        this.updateEventResponseReceived(data);
                        break;
                    case 'time':
                        this.setServerDate(data.payload.timeStamp).then(()=>{
                            this.refreshingTime();
                        });
                    break;
                    default: ''
                        break;
                }

            }

        },

        catchResponseFromCRMWS(data) {
            //filtro de resultados de websocket-> reciben componentes hijos
            if (data.hasOwnProperty('cmd') && data.hasOwnProperty('error')) {
                switch (data.cmd) {
                    case 'notifications':
                        this.filterNotificacion(data);
                        break;
                    default: ''
                        break;
                }
            }
            else if(data.hasOwnProperty('action')) {
                switch(data.action){
                    case "connect":
                        this.logedWS.crm = true;
                        this.ws.crm.uniqueWS = data.replyTo; 
                        console.log('[ws] login auntenticado con ID '+ this.ws.crm.uniqueWS+' -> para -> Websocket '+this.ws.crm.createdID)
                        this.tryingWebsocket.crm = false;
                        this.responseWS = {
                            "destiny": ["Menu"],
                            "message": '',
                            "payload": '',
                            "for": 'on',
                            "origin": 'deliveryNotifications',
                            "reload": false,
                        }
                        break;

                    case 'handleDuplicateAccount':
                        if(data.hasOwnProperty('replyDuplicate')){
                            if(data.replyDuplicate == this.ws.crm.uniqueWS){
                                this.closedAccountDub.crm = true;   
                            }
                        }
                        break;
                }
            }

        },

        activeOnicoWS() {
            console.log('[ws] conectando con servidor websocket: [' + this.appConfigCRM.ws.dir[1] + ']')
            //inicializar petitición websocket
            this.ws.onico = new WebSocket(this.appConfigCRM.ws.dir[1]);
            this.ws.onico.createdID = new Date().getTime();
            console.log('[ws] websocket onico ' + this.ws.onico.createdID + ' -> se ha creado');
            this.listenOnicoWS();
        },

        activeCRMWS(){
            console.log('[ws] conectando con servidor websocket: [' + this.appConfigCRM.ws.dir[0] + ']')
            //inicializar petitición websocket
            this.ws.crm = new WebSocket(this.appConfigCRM.ws.dir[0]);
            this.ws.crm.createdID = new Date().getTime();
            console.log('[ws] websocket crm ' + this.ws.crm.createdID + ' -> se ha creado');
            this.listenCRMWS();
        },

        forceCloseWS(wsName = null, close = 0) { //cierra conexion si existe
            try{
                this.wsOn[wsName] = false;
                this.manualClosedWS[wsName] = true;
                console.log('[ws] websocket '+this.ws[wsName].createdID+' -> cerrandose forzadamente');
                this.ws[wsName].close();
            }catch(err){
                console.log('[error/ws] al intentar cerrar websocket '+wsName);
                this.reload();
            }
        },

        manageErrWS(wsName = null, close = true, time=1000) { //cierra conexion y recarga

            if (close) {
                this.wsOn[wsName] = false;
                this.forceCloseWS(wsName);
            }

            this.timer(time).then(() => {
                if (this.onLine && !this.wsOn[wsName]) {
                    console.log('[ws] websocket intentando reconectar *'+wsName+'* websocket ');
                    this.ws[wsName] = null;
                    this.tryResetWS(wsName);
                } else {
                    console.log('[device] ***esperando conexion***', this.onLine, wsName, this.wsOn[wsName]);
                    this.manageErrWS(wsName, false);
                }
            })
        },

        tryResetWS(wsName = null) {
            switch(wsName){
                case "onico":
                    console.log('[ws] reconectando websocket onico');
                    this.activeOnicoWS();
                    break;
                case "crm":
                    console.log('[ws] reconectando websocket crm');
                    this.activeCRMWS();
                    break;
                default:
                    break;
            }
           
        },

        runErrorCleanerOnico(){ //cuenta los errores durante 5 segundos y si son 2 o más recarga la página
            if(this.failsCleanerTimerOnico == null){
                this.failsCleanerTimerOnico = setTimeout(() => {
                    if(this.countFailsOnico >= 2){
                        console.log('[error/device/red] errores acumulados '+this.countFailsOnico+' se recarga la pagina por posible bucle de conexion');
                        this.reload();
                    }else{
                        console.log('[error/device/red] websocket onico -> desconexiones detectadas en 5 segs: '+this.countFailsOnico, 'se hace reset a 0')
                        this.countFailsOnico = 0;
                        this.failsCleanerTimerOnico = null;
                    }
                }, 3000);
            }
        },

        listenOnicoWS() {
            //eventos de websocket directos

            this.ws.onico.onerror = (err) => {
                console.log(err)
                console.error('[error/ws] websocket onico ' + this.ws.onico.createdID + ' -> con error', JSON.stringify(err));
                this.manageErrWS('onico');
            }

            this.ws.onico.onmessage = (ev) => {
                if (this.wsOn.onico && (sessionStorage.ws == this.stringWS)) {
                    let data = JSON.parse(ev.data);
                    console.log("[ws] recibido de WS onico -> ", data)
                    this.catchResponseFromOnicoWS(data);
                }
            }

            this.ws.onico.onopen = () => {
                try{
                    this.wsOn.onico = true;
                    this.tryingWebsocket.onico = false;
                    console.log('[ws] websocket onico ' + this.ws.onico.createdID + ' -> se ha abierto correctamente')
                    console.log('[ws] websocket onico ' + this.ws.onico.createdID + ' -> esta escuchando')

                    if (this.appConfigCRM.token) {
                        console.log('[ws] websocket onico ' + this.ws.onico.createdID + ' -> intentando sincronizar el login-JWT')
                        this.tryToLoginExistendOnico();
                    } 
                }catch(err){
                    console.log('[error/ws] error al intentar abrir websocket onico, se recargara pagina');
                    this.reload();
                }  
            }

            this.ws.onico.onclose = (event) => {

                this.countFailsOnico += 1;
                this.runErrorCleanerOnico();

                this.responseWS = {
                    "destiny": [],
                    "message": '',
                    "payload": '',
                    "for": '',
                    "origin": 'err',
                    "desconection": true,
                    "reload": false,
                }


                if (this.manualClosedWS.onico) {
                    this.logedWS.onico = false;
                    this.wsOn.onico = false;
                    this.manualClosedWS.onico = false;
                    console.log('[ws] websocket onico ' + this.ws.onico.createdID + ' -> se ha cerrado por order interna')
                    this.ws.onico = null;
                } else {

                    if (this.logedWS.onico && this.closedAccountDub.onico) {
                        /*if(this.developer){
                            this.reload();
                        }*/
                        this.logedWS.onico = false;
                        this.wsOn.onico = false;
                        this.timeLogRuned = 1;
                        console.log('[ws] websocket onico ' + this.ws.onico.createdID + ' -> se ha cerrado desde el servidor')
                        console.log('[ws] websocket onico -> cuenta duplicada')
                        this.ws.onico = null;
                    } else if (this.logedWS.onico && !this.closedAccountDub.onico) {
                        this.wsOn.onico = false;
                        console.log('[ws] websocket onico ' + this.ws.onico.createdID + ' -> se ha cerrado sin motivo sin cuenta duplicada')
                        console.log('[ws] websocket onico -> se intentará reconectar')
                        this.tryingWebsocket.onico = true;
                        this.ws.onico = null;
                        setTimeout(() => {
                            this.tryResetWS('onico');
                        }, 2000)
                    } else{
                        this.wsOn.onico = false;
                        console.log('[ws] websocket onico ' + this.ws.onico.createdID + ' -> se ha cerrado sin motivo')
                        console.log('[ws] websocket onico -> se intentará reconectar')
                        this.ws.onico = null;
                        setTimeout(() => {
                            this.tryResetWS('onico');
                        }, 2000)
                    }

                }

            };

        },

        listenCRMWS() {

            this.responseWS = {
                "destiny": ["Menu"],
                "message": '',
                "payload": '',
                "for": 'off',
                "origin": 'deliveryNotifications',
                "reload": false,
            }

            this.ws.crm.onerror = (err) => {
                console.log('[ws/error] websocket crm ' + this.ws.crm.createdID + ' -> con error', JSON.stringify(err));
                this.manageErrWS('crm');
            }

            this.ws.crm.onmessage = (ev) => {
                if (this.wsOn.crm && (sessionStorage.ws == this.stringWS)) {
                    let data = JSON.parse(ev.data);
                    console.log("[ws] recibido de WS crm -> ", data)
                    this.catchResponseFromCRMWS(data);
                }
            }

            this.ws.crm.onopen = () => {
                this.wsOn.crm = true;
                this.tryingWebsocket.crm = false;
                console.log('[ws] websocket crm ' + this.ws.crm.createdID + ' -> se ha abierto correctamente')
                console.log('[ws] websocket crm ' + this.ws.crm.createdID + ' -> esta escuchando')

                if (this.appConfigCRM.token) {
                    console.log('[ws] websocket crm ' + this.ws.crm.createdID + ' -> intentando sincronizar el login-JWT')
                    this.tryToLoginCRM();
                }   
            }

            this.ws.crm.onclose = (event) => {

                if (this.manualClosedWS.crm) {
                    this.logedWS.crm = false;
                    this.wsOn.crm = false;
                    this.manualClosedWS.crm = false;
                    console.log('[ws] websocket crm ' + this.ws.crm.createdID + ' -> se ha cerrado por order interna')
                } else {

                    if (this.logedWS.crm && this.closedAccountDub.crm) {
                        if(this.developer){
                            this.reload();
                        }
                        this.logedWS.crm = false;
                        this.wsOn.crm = false;
                        this.timeLogRuned = 1;
                        console.log('[ws] websocket crm ' + this.ws.crm.createdID + ' -> se ha cerrado desde el servidor')
                        console.log('[ws] websocket crm -> cuenta duplicada')
                    } else if (this.logedWS.crm && !this.closedAccountDub.crm) {
                        this.wsOn.crm = false;
                        console.log('[ws] websocket crm ' + this.ws.crm.createdID + ' -> se ha cerrado sin motivo')
                        console.log('[ws] websocket crm -> se intentará reconectar')
                        this.tryingWebsocket.crm = true;
                        setTimeout(() => {
                            this.tryResetWS('crm');
                        }, 2000)
                    } else{
                        this.wsOn.crm = false;
                        console.log('[ws] websocket crm ' + this.ws.crm.createdID + ' -> se ha cerrado sin motivo')
                        console.log('[ws] websocket crm -> se intentará reconectar')
                        setTimeout(() => {
                            this.tryResetWS('crm');
                        }, 2000)
                    }

                }

            };

        },

         // >>> ENVIO HACIA WEBSOCKET >>>

        changeDoctorListening(data) {
            //cambia la conexión websocket de canal 

            if (this.logedWS.onico && this.wsOn.onico) {

                this.sendToElectron('setDoctor', data.doctor);

                this.ws.onico.send(JSON.stringify({
                    "cmd": "changeDoctor",
                    "payload": {
                        "jwt": data.jwt,
                        "idDoctor": data.doctor
                    }
                }
                ));

            } else {
                this.manageErrWS('onico')
            }
        },

        spaceTemporal(data, action) {
            //reservar/liberar espacios de calendario
            if (this.logedWS.onico && this.wsOn.onico) {
                let request = {
                    "cmd": "busyDate",
                    "payload": {
                        "start": data.start,
                        "end": data.end,
                        "action": action,
                        "jwt": data.jwt,
                        "idDoctor": data.doctor
                    }
                }
                if (data.hasOwnProperty('idAppointment')) { // si es bloqueo de modal
                    request.payload.idAppointment = data.idAppointment;
                }
                this.ws.onico.send(JSON.stringify(request));
            } else {
                this.manageErrWS('onico')
            }
        },

        appointReservation(data, action) {
            //marcar/liberar una cita como estar editando en calendario
            /*if (this.logedWS && this.wsOn) {
                this.ws.send(JSON.stringify({
                    "cmd": "reserveAppoint",
                    "payload": {
                        "idAppoint": data.idAppoint,
                        "action": action,
                        "jwt": data.jwt,
                        "idDoctor": data.doctor
                    }
                }
                ));
            } else {
                this.manageErrWS()
            }*/
        },

        createCredentials(data) {
            //log con datos del componente login
            if (this.wsOn.onico) {
                this.groupActive = data.groupActive;
                localStorage.setItem('groupActive', this.groupActive);
                this.ws.onico.send(JSON.stringify({
                    "cmd": "login",
                    "payload": {
                        "jwt": data.jwt,
                        "idDoctor": data.groupActive
                    }
                }));

            } else {
                this.manageErrWS('onico')
            }
        },

        tryToLoginExistendOnico() {
            //login con datos de localstorage
            this.ws.onico.send(JSON.stringify({
                    "cmd": "login",
                    "payload": {
                        "jwt": this.appConfigCRM.token,
                        "idDoctor": Object.keys(this.appConfigCRM.listDoctors)[0],
                    }
                }
            ));
        },

        tryToLoginCRM(){
            this.ws.crm.send(JSON.stringify({
                    "cmd": "login",
                    "payload": {
                        "jwt": this.appConfigCRM.token,
                    }
                }
            ));
        },

        // <<< RECEPCION DESDE WEBSOCKET <<<
        sucessLogin(data) {
            //recibe handshake de websocket
            if(!data.error){
                switch(data.action){
                case "connect":
                    this.logedWS.onico = true;
                    this.ws.onico.uniqueWS = data.replyTo; 
                    console.log('[ws] login auntenticado con ID '+ this.ws.onico.uniqueWS+' -> para -> Websocket '+this.ws.onico.createdID)
                    this.tryingWebsocket.onico = false;
                    break;

                case 'handleDuplicateAccount':
                    console.log('acaaaaaaaá')
                    if(!data.error){
                        if(data.replyDuplicate == this.ws.onico.uniqueWS){
                            this.closedAccountDub.onico = true;   
                        }
                    }
                    break;
                }
            }
        },

        newEventTeamReceived(data) {
            //evento realizado por elementos de licencia desde websocket, hacia calendario
            if (!data.error) {
                try{
                    this.responseWS = {
                        "destiny": ["Reserves", "listOrders"],
                        "message": data.message,
                        "payload": data.payload,
                        "for": data.action,
                        "origin": data.cmd,
                        "reload": false,
                    }
                }catch(err){console.log(err)}
            } else {
                this.responseWS = {
                    "destiny": ["Reserves", "listOrders"],
                    "reload": true,
                }
            }
        },

        newEventResponseReceived(data) {
            //respuesta de evento realizado por el mismo usuario desde websocket, hacia calendario
            if (!data.error) {
                this.responseWS = {
                    "destiny": ["Reserves"],
                    "message": data.message,
                    "payload": data.payload,
                    "for": data.action,
                    "origin": data.cmd,
                    "reload": false,
                }
            } else {
                this.responseWS = {
                    "destiny": ["Reserves"],
                    "reload": true,
                }
            }
        },

        updateEventTeamReceived(data) {
            //respuesta de evento realizado por el mismo usuario desde api, hacia calendario
            if (!data.error) {
                this.responseWS = {
                    "destiny": ["Reserves"],
                    "message": data.message,
                    "payload": data.payload,
                    "for": data.action,
                    "origin": data.cmd,
                    "reload": false,
                }
            } else {
                this.responseWS = {
                    "destiny": ["Reserves"],
                    "reload": true,
                }
            }
        },

        updateEventResponseReceived(data) {
            //respuesta de evento realizado por el mismo usuario desde api, hacia calendario
            if (!data.error) {
                this.responseWS = {
                    "destiny": ["Reserves"],
                    "message": data.message,
                    "payload": data.payload,
                    "for": data.action,
                    "origin": data.cmd,
                    "reload": false,
                }
            } else {
                this.responseWS = {
                    "destiny": ["Reserves"],
                    "reload": true,
                }
            }
        },
        

        renderNotificacionCordova(data, mode){
            cordova.plugins.notification.local.hasPermission( (granted) => {
                if(granted){

                    localStorage.removeItem('systemNotificationsOff')

                    let notificationOptions = {
                        title: data.title,
                        text: data.message,
                        vibrate: true,
                        foreground: false
                    };

                    if(mode == "newOrders"){
                        notificationOptions.actions = [{ id: 'getNowOrders', title: 'Ver ordenes nuevas' }];
                        notificationOptions.smallIcon = 'https://mikele.efisen.se/apiCRM/icon.png';
                        notificationOptions.icon = 'https://mikele.efisen.se/apiCRM/icon.png';
                    }

                    cordova.plugins.notification.local.schedule(notificationOptions);
                }
            });
        },

        renderNotification(data, mode){
            if(this.isElectron){ //notificacion via electron
                this.sendToElectron('notify', JSON.stringify(data.payload));
            }else if(this.isCordova){ //notificacion via cordova
                this.renderNotificacionCordova(data.payload, mode);
            }
        },

        filterNotificacion(data){
            if (!data.error) {

                switch(data.action){
                    case "newOrders": //solo si tiene el modulo de lista de ordenes
                        if(this.appConfigCRM.modules.includes('listOrders')){
                            this.renderNotification(data, 'newOrders');
                            this.responseWS = {
                                "destiny": ["listOrders"],
                                "message": data.message,
                                "title": data.title,
                                "payload": JSON.stringify(data.payload),
                                "for": data.action,
                                "origin": data.cmd,
                                "reload": false,
                            }   
                        }
                        break;
                    default:
                        break;
                }
 
            }
        },

        /* HELPER FUNCTIONS */

        setServerDate(timeSTP) {
            return new Promise((resolve) => {
                console.log('[time/ws]', this.serverDate, new Date(timeSTP * 1000), timeSTP, 'tiempo de servidor websocket');
                this.serverDate = new Date(timeSTP * 1000);
                resolve(true)
            })
        },

        getServerTime(){
            console.log('[time/ws] obteniendo tiempo del servidor por websocket');
            this.ws.onico.send(JSON.stringify({
                        "cmd": "time",
                        "payload": {
                        "zone":"MX"
                        }
                    }
            ));
        },

        refreshingTime() { // recursiva de tiempo, para refrescar los componentes a fecha-hora actuales
            console.log('[time] reintegrando intervalo actualizador de tiempos');
            if(this.interval != null){
                clearInterval(this.interval);
            }
            this.interval = setInterval(() => {
                this.serverDate = new Date((this.serverDate).getTime()+60000);
            }, 60000);
        },


        reload() {
            //recargar ventana completamente
            console.log('[device] recargando pagina')
            window.location.reload();
        },

        timer(time) {
            //función de espera asíncrona
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(true);
                }, time);
            });
        },


        /* --- */
        

        goToRoute(data, mode="replace") {
            if(this.$route.meta.requiresCarComprobation){
                if(localStorage.car){
                    if(localStorage.car != "[]"){
                        this.lastRoute = {'data':data, 'mode':mode};
                        this.notify = [true, "Has agregado artículos al carrito de orden.<br> ¿Deseas salir y descartar los artículos?", "danger", 5, "Salir y descartar", ["eraseCarContinue"], false, true, true];
                        return false;
                    }
                }
            }
            switch(mode){
                case "replace":
                    if(data.dir && data.parameters){
                        this.$router.replace({ path: data.dir, query: data.parameters});
                    }else{
                        this.$router.replace(data.destiny);
                    }
                    break;
                case "push":
                default:
                    if(data.dir && data.parameters){
                        this.$router.push({ path: data.dir, query: data.parameters});
                    }else{
                        this.$router.push(data.destiny);
                    }
                    break;
            }
        },
        setTitle(title) {
            document.title = title;
        },
        showConfDevice(){
            this.responseElectron = {
                "destiny": ["Menu"],
                "payload": {
                    "action": "openConfigDevice",
                },
                "reload": false,
            }
        },
        sendUsbList(data){
            this.responseElectron = {
                "destiny": ["deviceConfiguration"],
                "payload": {
                    "action": "usbList",
                    "data": data,
                },
                "reload": false,
            }
        },
        setOrders(data, user, path){
            localStorage.setItem('userTablesCRM', JSON.stringify(data));
            localStorage.setItem('userCRM', JSON.stringify(user));
            sessionStorage.setItem('first', true);
            this.goToRoute({destiny:path}, 'push');
        },
        logout(){
            if(this.$route.name != 'logScreen'){
                this.goToRoute({destiny:'/logScreen'}, "replace");
            }
        },
        printThermal(data){
            return new Promise(async (resolve)=>{

                if(this.isElectron){
                    this.sendToElectron('sendPrint', data);
                }else{
                    this.printer.parseTicket(data).then((parsed)=>{
                        this.printer.printTicket(parsed).then((response)=>{
                            if(response.status == "fail"){
                                this.setToast(response.mess);
                            }
                            resolve(true)
                        })
                    })
                }

            })
        },
        filterEvent(data){
            switch(data.ev){
                case "pedingNewTableEntrance":
                    this.goToRoute({dir:'/menuEntrance', parameters:data}, "replace");
                    break;
                case "pedingNewTable":
                    this.goToRoute({dir:'/menuOrder', parameters:data}, "replace");
                    break;
                case "updateTable":
                    this.goToRoute({dir:'/menuOrder', parameters:data}, "push");
                    break;
                case "printThermal":
                    this.printThermal(data.data);
                    break;
                case "openConfigDev":
                    this.modals.devConf.status = true;
                    break;
                case "playSound":
                    this.playSound(data.sound);
                    break;
            }
        }
    }
}
</script>

<style lang="css">

    body {
        overflow: hidden;
        font-family: 'Helvetica Neue', sans-serif !important;
        background-color: var(--secondary);
    }

    .slide-enter-active, .slide-leave-active {
        transition: all .25s ease-out;
    }

    .slide-enter-to {
        position: absolute;
        right: 0;
    }

    .slide-enter-from {
        position: absolute;
        right: -100%;
    }

    .slide-leave-to {
        position: absolute;
        left: -100%;
    }

    .slide-leave-from {
        position: absolute;
        left: 0;
    }

    /** -- **/
    
    .scale-enter-active,
    .scale-leave-active {
        transition: all 0.1s ease;
    }
    .scale-enter-from,
    .scale-leave-to {
        opacity: 0;
        transform: scale(0.9);
    }


    /** -- **/

    .scale-slide-enter-active,
    .scale-slide-leave-active {
        position: absolute;
        transition: all 0.30s ease;
    }
    .scale-slide-enter-from {
        left: -100%;
    }
    .scale-slide-enter-to {
        left: 0%;
    }
    .scale-slide-leave-from {
        transform: scale(1);
    }
    .scale-slide-leave-to {
        transform: scale(0.8);
    }

    /** -- **/


#updatingAPP,
#errorConection,
#errorWebsocket,
#a25,
#tryingWebsocket {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: var(--secondary);
    color: #fff;
    font-size: 25px;
    font-weight: bold;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    top: 0;
    left: 0;
}

#updatingAPP {
    display: flex;
    z-index: 6000;
}

#updatingAPP img{
    width:200px;
    margin-top:40px;
}

#errorConection {
    display: flex;
    z-index: 2004;
}

#errorWebsocket {
    display: flex;
    z-index: 2001;
}

#a25 {
    display: flex;
    z-index: 2000;
}

#tryingWebsocket{
    display: flex;
    z-index: 2003;
}

#a25 img {
    width: 150px;
    height: auto
}

.btn-ok {
    background: var(--primary);
    border: 1px solid var(--primary);
    border-radius: 6px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px 2px;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    font-weight: 800;
    line-height: 16px;
    min-height: 40px;
    outline: 0;
    padding: 20px 38px;
    text-align: center;
    text-rendering: geometricprecision;
    text-transform: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    vertical-align: middle;
}

.btn-ok:hover,
.btn-ok:active {
    background-color: #fff;
    background-position: 0 0;
    color: var(--primary);
}

.btn-ok:active {
    opacity: .5;
}

.cache{
    opacity: 0;
    position: fixed;
    pointer-events: none;
}

.stringVersionTitle{
    font-size: 35px;
    color: #fff;
    line-height: 1.2;
}

.stringVersion{
    font-size: 16px;
    color: #fff;
    line-height: 1.2;
}

.icon1{
    width: 3vw;
}

.icon2{
    width: 8vw;
}

#updateScreen{
    position: fixed;
    left: 0;
    top:0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 3999;
}

</style>

